import React, { useState } from 'react';

import styled from '@emotion/styled';

import { Breadcrumb, Panel, NavLinkButton, Table } from '@shared/components/bootstrap';

import { DebouncedInputFormGroup } from '@admin/components/fields';
import { PageHeader } from '@admin/components/helpers/page_header';
import { Pagination } from '@admin/components/pagination';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { usePaginatedLandingLocationPagesQuery } from '@admin/schema';

const INITIAL_PAGE = 1;

const Links = styled.div`
  display: flex;
  gap: 4px;
`;

export const LandingLocationPageList: React.FC = () => {
  useTitle('Landing - Location - Pages');
  const [page, setPage] = useState<number>(INITIAL_PAGE);
  const [query, setQuery] = useState<string | undefined>();
  const { data, loading } = usePaginatedLandingLocationPagesQuery({
    client,
    fetchPolicy: 'cache-and-network',
    variables: {
      page,
      query,
    },
  });

  const paginated = data?.paginated;

  return (
    <>
      <PageHeader>
        <Breadcrumb>
          <Breadcrumb.Item>Landing</Breadcrumb.Item>
          <Breadcrumb.Item>Location</Breadcrumb.Item>
          <Breadcrumb.Item active>Pages</Breadcrumb.Item>
        </Breadcrumb>
      </PageHeader>

      <Panel>
        <Panel.Body>
          <DebouncedInputFormGroup
            placeholder="Search"
            initial={query}
            onDebounce={(value) => {
              setQuery(value);
              setPage(INITIAL_PAGE);
            }}
          />
        </Panel.Body>
      </Panel>

      <Panel>
        <Panel.Body>
          <Table responsive striped>
            <thead>
              <tr>
                <th className="text-left">ID</th>
                <th className="text-left">Slug</th>
                <th className="text-left">Title</th>
                <th className="text-left">Description</th>
                <th className="col-zero" />
              </tr>
            </thead>
            <tbody>
              {paginated?.results.map((entry) => (
                <tr key={entry.id}>
                  <td className="text-left">{entry.id}</td>
                  <td className="text-left">{entry.slug}</td>
                  <td className="text-left">{entry.title}</td>
                  <td className="text-left">{entry.description}</td>
                  <td className="col-zero">
                    <Links>
                      <NavLinkButton kind="primary" to={`/landing/location/pages/${entry.id}/edit`}>
                        Edit
                      </NavLinkButton>
                      <NavLinkButton kind="primary" to={`/landing/location/pages/${entry.id}`}>
                        View
                      </NavLinkButton>
                    </Links>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {loading && <Spinner />}
          {paginated && <Pagination onPage={setPage} pagination={paginated.pagination} />}
        </Panel.Body>
        <Panel.Footer align="right">
          <NavLinkButton kind="primary" to="/landing/location/pages/new">
            New
          </NavLinkButton>
        </Panel.Footer>
      </Panel>
    </>
  );
};
